import React, { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import Alert from "@material-ui/lab/Alert";
import EventLabel2, { init } from "../../components/EventLabel2/EventLabel2";
import { Spinner } from "reactstrap";

const GroupGeneratorModule = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [clicked, setClicked] = useState(false);
  const { hubConnection, clientKey, eventId, lang, settings, preview, template } = props;
  const { breakoutId, rooms, max, text } = settings;

  const randomButtonFullCheckTimerRef = useRef(null);

  useEffect(() => {
    init(eventId, "DigitalMeeting.GroupGenerator", lang);
    if (hubConnection && !preview) {
      hubConnection.on("onGetFirstAvailableBreakout", onGetFirstAvailableBreakout);
      hubConnection.on("onRandomButtonFullCheck", onRandomButtonFullCheck);
    }
  }, []);

  const onRandomButtonFullCheck = ({ code, breakoutId }) => {
    if (randomButtonFullCheckTimerRef.current) {
      clearInterval(randomButtonFullCheckTimerRef.current);
    }
    if (code == "OPEN" && breakoutId == settings.breakoutId) {
      setIsButtonDisabled(false);
    } else {
      randomButtonFullCheckTimerRef.current = setInterval(randomButtonFullCheck, 15000);
      if (code == "FULL" && breakoutId == settings.breakoutId) {
        setIsButtonDisabled(true);
      }
    }
    setClicked(false);
  };
  const randomButtonFullCheck = () => {
    if (!breakoutId) return;

    hubConnection.invoke("getBreakoutChannel", eventId, breakoutId, rooms, max, clientKey, true);
  };
  const getFirstAvailableBreakout = () => {
    if (!breakoutId) return;
    setClicked(true);
    hubConnection.invoke("getBreakoutChannel", eventId, breakoutId, rooms, max, clientKey, false);
  };
  const onGetFirstAvailableBreakout = (code, channel) => {
    setClicked(false);
    window.location.href = `${window.location.origin}${
      !window.location.toString().includes("localhost") ? "/interaction" : ""
    }/digitalarena/${code}?clientkey=${clientKey}&channel=${channel}&lang=${lang}`;
  };

  return (
    <button
      disabled={isButtonDisabled || preview}
      style={{
        ...template.button,
        padding: "6px 12px",
        width: "100%",
        height: "100%",
        cursor: isButtonDisabled ? "default !important" : "pointer",
        opacity: isButtonDisabled ? 0.7 : 1,
      }}
      onClick={() => getFirstAvailableBreakout()}
    >
      {isButtonDisabled ? <EventLabel2 name="RoomFull" groupName="DigitalMeeting.GroupGenerator" /> : clicked ? <Spinner /> : <span>{text}</span>}
    </button>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : undefined,
  };
}
export default connect(mapStateToProps)(GroupGeneratorModule);
